<template>
    <div class="container-wrapper">
        <div>Container <b>#{{data.code}}</b></div>
        <samples-list :items="data.samples" class="samples"></samples-list>
        <v-btn small text color="success">
            Add samples
        </v-btn>
    </div>
</template>

<script>
import SamplesList from '../Samples/List'
export default {
    name: 'Item',
    props: {
        data: Object
    },
    components: {
        SamplesList
    }
}
</script>

<style scoped>
    .container-wrapper {
        margin-top: 20px;
        padding: 15px;
        border: 1px dotted #cacaca;
        border-radius: 3px;
    }

    .samples {
        margin: 15px;
    }
</style>